import { Button, Col, Form, Row, Switch } from "antd";
import React from "react";
import { Controller, UseFormReturn } from "react-hook-form";

import { SelectOption } from "../../../libs/types";
import { InputField, SelectField } from "../../atoms/FormElement";

import { EnablementFlagFormData } from "./types";

export type EnablementFlagFormProps = {
  methods: UseFormReturn<EnablementFlagFormData>;
  organizationOptions: SelectOption[];
  isSubmitting?: boolean;
  onSubmit: (data: EnablementFlagFormData) => void;
  onCancel: () => void;
};

export const EnablementFlagForm = (props: EnablementFlagFormProps) => {
  const { methods, organizationOptions, isSubmitting = false, onSubmit, onCancel } = props;
  const { control, formState, handleSubmit } = methods;
  const { errors } = formState;

  return (
    <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
      <Row gutter={12}>
        <Col span={24}>
          <SelectField
            isRequired
            fieldname="organization"
            label="Organization"
            control={control}
            isDisabled
            selectOption={organizationOptions}
            rules={{ required: "This field is required" }}
            iProps={{ placeholder: "Select Organization" }}
            validate={errors?.organization && "error"}
            validMessage={errors?.organization?.message}
          />
        </Col>
        <Col span={24}>
          <InputField
            isRequired
            fieldname="flag"
            label="Flag"
            control={control}
            rules={{ required: "This field is required" }}
            iProps={{ placeholder: "e.g. enableWriteOff" }}
            validate={errors?.flag && "error"}
            validMessage={errors?.flag?.message}
          />
        </Col>
        <Col span={24}>
          <Form.Item label="Status" style={{ marginBottom: 24 }}>
            <Controller
              name="value"
              control={control}
              render={({ field }) => (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Switch className="switch" checked={field.value} onChange={field.onChange} />
                  <span>{field.value ? "Active" : "Inactive"}</span>
                </div>
              )}
            />
          </Form.Item>
        </Col>
        <Col span={24} style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={isSubmitting}>
            Add
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
